import { useMutation } from "react-query";

import { ServiceSupplier } from "g1-commons/lib/doxecureTypes";

import { useAuthContext } from "@hooks/useAuthContext";
import { connectUserToDrive } from "@services/drive.service";

export const useConnectToDrive = () => {
    const { profileId } = useAuthContext();

    return useMutation(({ provider, redirectUri }: { provider: ServiceSupplier; redirectUri: string }) =>
        connectUserToDrive(profileId, provider, redirectUri)
    );
}